<a color="primary" mat-icon-button [matMenuTriggerFor]="menu" aria-label="Menu" class="main-menu">
  <mat-icon>reorder</mat-icon>
</a>
<mat-menu #menu="matMenu">
  <button mat-menu-item (click)="toLogout()">
    <mat-icon>logout</mat-icon>
    <span>Logout</span>
  </button>
</mat-menu>
